import React, { useRef } from "react";

import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";
import { CRM_PET_TABS } from "../constants";

export function CrmPetTabs() {
  const CCrmPet = CrmPetController();
  const activeRule = useCrmPet((state) => state.data.filter.rule);
  const config = useCrmPet((state) => state.data.config);
  const isWaiting = useCrmPet((state) => state.data.isWaiting);
  const tabRefs = useRef({});

  const enabledTabs = CRM_PET_TABS.filter((tab) => {
    if (tab.value === "ALL" || !config.rules.length) return true;
    return config.rules.find((rule) => rule.ruleCode === tab.value)?.active === true;
  });

  const selectTab = async (value) => {
    if (value === activeRule || isWaiting) return;
    await CCrmPet.selectRule(value);
  };

  const handleKeyDown = (event, value) => {
    const currentIndex = enabledTabs.findIndex((tab) => tab.value === value);
    if (currentIndex < 0) return;

    let nextIndex = null;
    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % enabledTabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + enabledTabs.length) % enabledTabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = enabledTabs.length - 1;
    if (nextIndex === null) return;

    event.preventDefault();
    const nextTab = enabledTabs[nextIndex];
    tabRefs.current[nextTab.value]?.focus();
    selectTab(nextTab.value);
  };

  return (
    <div
      aria-label="Visões do CRM Pet"
      className="flex w-full gap-1 border-b border-gray-200"
      role="tablist"
    >
      {CRM_PET_TABS.map((tab) => {
        const rule = config.rules.find((item) => item.ruleCode === tab.value);
        const inactive = tab.value !== "ALL" && config.rules.length > 0 && rule?.active !== true;
        const active = activeRule === tab.value;

        return (
          <button
            key={tab.value}
            ref={(element) => { tabRefs.current[tab.value] = element; }}
            aria-controls="crm-pet-table-panel"
            aria-selected={active}
            className={`relative min-w-max border-0 bg-transparent px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-scale-300 ${active
              ? "text-scale-600 after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-scale-500"
              : "text-gray-500 hover:text-scale-500"}`}
            disabled={inactive || isWaiting}
            id={`crm-pet-tab-${tab.value.toLowerCase()}`}
            onClick={() => selectTab(tab.value)}
            onKeyDown={(event) => handleKeyDown(event, tab.value)}
            role="tab"
            tabIndex={active ? 0 : -1}
            title={inactive ? `${tab.label} (régua inativa)` : tab.label}
            type="button"
          >
            {tab.label}
            {inactive && <span className="ml-1 text-[10px] font-normal text-gray-400">(inativa)</span>}
          </button>
        );
      })}
    </div>
  );
}
